import { render, staticRenderFns } from "./FeaturedArticles.vue?vue&type=template&id=b232cb26&scoped=true&"
import script from "./FeaturedArticles.vue?vue&type=script&lang=js&"
export * from "./FeaturedArticles.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedArticles.vue?vue&type=style&index=0&id=b232cb26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b232cb26",
  null
  
)

export default component.exports